<template>
  <kendo-multicolumncombobox
      ref="cmpyNmRef"
      :data-source="this.$store.state.codeRequestStore.search.combobox.cmpyNmForUser.data"
      :data-text-field="'cmpyNm'"
      :data-value-field="'cmpyId'"
      :columns="customColumns"
      :filter-fields="customFilters"
      :label="label"
      :text="'회사를 선택해주세요.'"
      :filter="'contains'"
      :style="'width: 100%;'"
      @change="onChangeCmpyId"
  >
  </kendo-multicolumncombobox>
</template>

<script>
import ApiConfig from '@/api/api.config'
import ApiUtil from '@/api/api.util'
import EtnersParseUtil from '@/common/etners.parse.util'

export default {
  name: 'MultiDropdownCompany',
  mounted () {
    const vm = this
  },

  methods: {
    onChangeCmpyId () {
      const vm = this
      const refs = vm.$refs
      const cmpyId = refs.cmpyNmRef.kendoWidget().value()

      vm.$emit("changeCmpyId", cmpyId)
    },
  },

  data () {
    return {
      loginUserToken: sessionStorage.getItem('loginUserToken'),
      label: {
        content: '회사를 선택해주세요.',
        floating: true
      },
      customColumns: [
        {
          field: 'cmpyNm',
          title: '회사명',
        },
        {
          field: 'corporateRegNo',
          title: '사업자등록번호',
          template(dataItem) {
            return !!dataItem.corporateRegNo ? dataItem.corporateRegNo : '-'
          },
        },
      ],
      customFilters: [
        'cmpyNm', 'corporateRegNo'
      ],
    }
  },
}
</script>

